import { Component, Input } from '@angular/core';

import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-error-modal',
    templateUrl: './error-modal.component.html',
    styleUrls: ['./error-modal.component.scss'],
})
export class ErrorModalComponent {
    @Input() public errors: any[];

    @Input() public isOwnError: boolean;

    public isProd = environment.production;
}
